<template>
    <basic-card>
        <template slot="header">{{displayName}}</template>
        <div class="exchange-rate-wrapper">
            <div style="font-size: 24px;">
                {{$formats.formatNumber(actualRate.rates[0].value / 1000, '0.00000')}}
            </div>
            <div>
                {{actualRate.primaryCurrency}}/{{actualRate.secondaryCurrency}}
            </div>
            <div>
                Interday change: <div class="rate-change" :style="{'color': rateChange < 0 ? '#c13e3d' : '#96f364'}">{{rateChange > 0 ? "+" : ""}}{{$formats.formatNumber(rateChange, '0.00000')}}</div>

            </div>
        </div>
    </basic-card>
</template>

<script>
    import BasicCard from "../../layout/BasicCard";
    import {mapGetters} from "vuex";
    export default {
        name: "SimpleExchangeRateWidget",
        props: {
            displayName: String,
            exchangeRate: String
        },
        components: {BasicCard},
        computed: {
            ... mapGetters({
                "exchangeRates": "currencies/exchangeRates"
            }),
            actualRate() {
                return this.exchangeRates.find(exRate => exRate.id == this.exchangeRate);
            },
            rateChange() {
                return (this.actualRate.rates[0].value - this.actualRate.rates[1].value)  / 1000;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .exchange-rate-wrapper {
        &>* {
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            justify-items: center;
        }
        width: 100%;
        display: flex;
        flex-flow: column;
        justify-content: center;
    }

    .rate-change {
        display: inline-block;
    }
</style>